import { listingAPI } from '../lib/api';

export interface Policy {
  id: string;
  propertyId: string;
  tenantId: string;
  type: 'CANCELLATION' | 'HOUSE_RULES' | 'CHECK_IN' | 'REFUND' | 'PET' | 'CHILD';
  title: string;
  content: string;
  cancellationType?: 'FLEXIBLE' | 'MODERATE' | 'STRICT' | 'NON_REFUNDABLE';
  createdAt: string;
  updatedAt: string;
}

export const policyService = {
  // Backend wraps every response in a { success, data } envelope (successResponse) -- this only
  // unwrapped one level (r.data, the envelope itself) instead of two (r.data.data, the actual
  // array), so every consumer's "policies" was really { success: true, data: [...] }, an object,
  // not an array. Crashed ListingReviewPage outright ("m.find is not a function") the first time
  // anyone actually reviewed a property with a cancellation policy set.
  getByProperty: (propertyId: string) =>
    listingAPI.get<{ data: Policy[] }>(`/v1/policies/properties/${propertyId}/policies`).then((r) => r.data.data),

  create: (propertyId: string, data: { type: string; title: string; content: string; cancellationType?: string }) =>
    listingAPI.post<Policy>(`/v1/policies/properties/${propertyId}/policies`, data).then((r) => r.data),

  update: (id: string, data: { title?: string; content?: string; cancellationType?: string }) =>
    listingAPI.patch<Policy>(`/v1/policies/${id}`, data).then((r) => r.data),

  delete: (id: string) =>
    listingAPI.delete(`/v1/policies/${id}`).then((r) => r.data),
};
